import { RuleType, RuleTypes } from "interfaces/ruleType";

export const getRulesTypes = (ruleEntityType: "subject" | "zone") => {
  if (!ruleEntityType) {
    return [];
  }

  let rules: RuleType[] = [RuleTypes.Awake];

  if (ruleEntityType !== "subject") {
    rules.push(RuleTypes.DeviceOffline);
  }

  rules = rules.concat([
    RuleTypes.Movement,
    RuleTypes.NoPresence,
    RuleTypes.RRDeviation,
    RuleTypes.SoundLevel,
  ]);

  return rules;
};
